import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import siteData from "../data/siteData.json";

function Home() {
  const carouselCloneRan = useRef(false);

  useEffect(() => {
    if (carouselCloneRan.current) return;
    carouselCloneRan.current = true;

    let items = document.querySelectorAll(
      ".completed-projects .carousel .carousel-item",
    );
    items.forEach((el) => {
      const minPerSlide = 4;
      let next = el.nextElementSibling;
      for (var i = 1; i < minPerSlide; i++) {
        if (!next) {
          // wrap carousel by using first child
          next = items[0];
        }
        let cloneChild = next.cloneNode(true);
        el.appendChild(cloneChild.children[0]);
        next = next.nextElementSibling;
      }
    });
  }, []);

  const { completedProjects, testimonials, company } = siteData;

  return (
    <>
      <header
        className="video-hero position-relative overflow-hidden"
        style={{ height: "100vh" }}
      >
        <video
          autoPlay
          muted
          loop
          playsInline
          className="w-100 h-100"
          style={{ objectFit: "cover" }}
        >
          <source src="/img/1.mp4" type="video/mp4" />
        </video>
      </header>

      <aside className="sticky-top sticky-offset">
        <ul className="sp">
          <li className="s-phone">
            <button>
              <a href={company.phoneHref}>
                <i className="fa fa-phone"></i>
              </a>
            </button>
          </li>
        </ul>
        <ul className="sp">
          <li className="s-phone">
            <button>
              <a href={`mailto:${company.email}`}>
                <i className="fa fa-envelope"></i>
              </a>
            </button>
          </li>
        </ul>
      </aside>

      <section className="completed-projects pt-5 pb-5">
        <div className="full-width-container">
          <div className="row mx-auto my-auto justify-content-center">
            <div className="col-md-12">
              <div className="title">
                <h1>Completed Projects</h1>
                <p className="section-subtitle">
                  {siteData.completedProjectsLocations}
                </p>
              </div>
            </div>
            <div
              id="recipeCarousel"
              className="carousel slide"
              data-bs-ride="carousel"
            >
              <div className="carousel-inner" role="listbox">
                {completedProjects.map((project, index) => (
                  <div
                    className={`carousel-item${index === 0 ? " active" : ""}`}
                    key={project.id}
                  >
                    <div className="col-md-3">
                      <div className="project-mas hover-shadow">
                        <div className="image-effect-one">
                          <img src={project.image} alt={project.name} />
                          <span className={`badge-status ${project.badgeClass}`}>
                            {project.badge}
                          </span>
                          <span
                            className="map-icon-btn"
                            data-bs-toggle="modal"
                            data-bs-target={`#${project.mapModalId}`}
                          >
                            <i className="fa fa-map-marker"></i>
                          </span>
                        </div>
                        <div className="project-info">
                          <h4>{project.name}</h4>
                          <p className="project-desc">{project.desc}</p>
                          <div className="project-details">
                            <div className="detail-item">
                              <i className="fa fa-home"></i>{" "}
                              <strong>{project.config}</strong>
                            </div>
                            <div className="detail-item">
                              <i className="fa fa-map-marker"></i>{" "}
                              <strong>{project.location}</strong>
                            </div>
                          </div>
                          <div className="rera-info">
                            <span className="rera-badge">
                              RERA: {project.rera}
                            </span>
                          </div>
                          <div className="project-cta">
                            <button className="btn-enquire">
                              <a className="read">ENQUIRE NOW</a>
                            </button>
                            <button className="btn-visit">
                              <a
                                href="/pdf/Brochure.pdf"
                                target="_blank"
                                className="read"
                              >
                                <i className="fa fa-download"></i>  DOWNLOAD
                              </a>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <a
                className="carousel-control-prev"
                href="#recipeCarousel"
                role="button"
                data-bs-slide="prev"
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Previous</span>
              </a>
              <a
                className="carousel-control-next"
                href="#recipeCarousel"
                role="button"
                data-bs-slide="next"
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Next</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {completedProjects.map((project) => (
        <div
          className="modal fade map-modal"
          id={project.mapModalId}
          tabIndex="-1"
          aria-hidden="true"
          key={project.mapModalId}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{project.mapTitle}</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <iframe
                  src={project.mapEmbed}
                  width="100%"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title={`${project.name} Location Map`}
                ></iframe>
                <div className="location-info">
                  <p>
                    <i className="fa fa-map-marker"></i>{" "}
                    <strong>Address:</strong> {project.mapAddress}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      <section className="testimonials pt-5 pb-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="title text-center">
                <h1>Ratings</h1>
                <p className="section-subtitle">Trusted by 300+ Happy Families</p>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12">
              <div
                id="testimonialCarousel"
                className="carousel slide"
                data-bs-ride="carousel"
              >
                <div className="carousel-inner" style={{ padding: "0 50px" }}>
                  {testimonials.map((testimonial, index) => (
                    <div
                      className={`carousel-item${index === 0 ? " active" : ""}`}
                      key={testimonial.author}
                    >
                      <div className="testimonial-card">
                        <div className="testimonial-content">
                          <div className="quote-icon">
                            <i className="fa fa-quote-left"></i>
                          </div>
                          <p className="testimonial-text">
                            {testimonial.text}
                          </p>
                          <div className="testimonial-rating">
                            <i className="fa fa-star"></i>
                            <i className="fa fa-star"></i>
                            <i className="fa fa-star"></i>
                            <i className="fa fa-star"></i>
                            <i className="fa fa-star"></i>
                          </div>
                          <div className="testimonial-author">
                            <h4>{testimonial.author}</h4>
                            <p>{testimonial.designation}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#testimonialCarousel"
                  data-bs-slide="prev"
                >
                  <span
                    className="carousel-control-prev-icon"
                    aria-hidden="true"
                  ></span>
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#testimonialCarousel"
                  data-bs-slide="next"
                >
                  <span
                    className="carousel-control-next-icon"
                    aria-hidden="true"
                  ></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="location pt-5" style={{ background: "#f5f5f5" }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="project-heading">
                <p>LOCATIONS OF OUR PROJECTS</p>
                <h2>JVPD SCHEME</h2>
              </div>
            </div>
          </div>
        </div>
        <style>{`
        .map-container {
          position: relative;
          width: 100%;
          max-width: 100%;
          margin: auto;
          border-radius: 0;
          overflow: visible;
        }
        #map-image {
          width: 100%;
          height: auto;
          border-radius: 0;
        }
      `}</style>
        <div className="map-container">
          <img src="/img/location.jpg" alt="Map" id="map-image" />
        </div>
      </section>
    </>
  );
}

export default Home;